export default{
    女装: "Pakaian wanita",
    男装: "Lelaki",
    手机和小工具: "Telefon bimbit dan gajet",
    居家生活: "kehidupan rumah",
    电脑及周边设备: "Komputer dan peralatan persisian",
    美容及个人护理: "Kecantikan dan penjagaan diri",
    家用电器: "perkakas rumah",
    健康与保健: "kesihatan dan kesejahteraan",
    食品和饮料: "makanan dan minuman",
    玩具_儿童和婴儿: "mainan, kanak-kanak dan bayi",
    童装时尚: "fesyen kanak-kanak",
    视频游戏: "permainan video",
    运动与户外: "Sukan dan Luar",
    爱好与书籍: "Hobi dan buku",
    相机和无人机: "Kamera dan dron",
    宠物食品及用品: "Makanan dan bekalan haiwan kesayangan",
    女士包袋: "beg wanita",
    男士包袋: "beg lelaki",
    珠宝及配饰: "Barang Kemas dan Aksesori",
    手表: "menonton",
    女鞋: "kasut wanita",
    男装鞋: "kasut lelaki",
    汽车: "kereta",
    我附近的ShopeePay: "ShopeePay berhampiran saya",
    餐饮_旅行和服务: "Katering, pelancongan dan perkhidmatan",
    旅行及行李: "Perjalanan dan bagasi",
    各种各样的: "Jenis lain",
    我是来买什么的: "Apa yang saya ada di sini untuk membeli?",
    对不起_找不到_相关的商品: "Maaf, tiada produk yang berkaitan dengan [{0}] ditemui",
    类别: "kategori",
    产品: "produk",
    店铺: "kedai",
    首页: "muka depan",
    限时秒杀: "Jualan kilat masa terhad",
    博客: "blog",
    所有品牌: "Semua jenama",
    所有类别: "Semua Kategori",
    我的购物车: "keranjang belanja saya",
    发货信息: "maklumat penghantaran",
    交货信息: "Maklumat penghantaran",
    付款: "Bayaran",
    确认: "mengesahkan",
    您的购物车是空的: "Troli beli-belah anda kosong",
    价格: "harga",
    税: "Cukai",
    数量: "kuantiti",
    总计: "jumlah",
    移除: "Alih keluar",
    返回商店: "Kembali ke kedai",
    继续发货: "Teruskan menghantar",
    筛选: "penapis",
    价格范围: "julat harga",
    排序方式: "disusun mengikut",
    最新: "terkini",
    最旧: "tertua",
    价格从低到高: "Harga dari rendah ke tinggi",
    价格从高到低: "Harga dari tinggi ke rendah",
    选择交货类型: "Pilih jenis penghantaran",
    送货上门: "Penghantaran",
    继续付款: "Terus bayar",
    任何其他信息: "sebarang maklumat lain",
    或者: "atau",
    您的钱包余额: "Baki dompet anda",
    余额不足: "Baki tidak mencukupi",
    支付: "bayar",
    我同意: "saya setuju",
    条款和条件: "terma dan syarat",
    退货政策: "syarat pengembalian",
    隐私政策: "Dasar Privasi",
    概括: "membuat generalisasi",
    项目: "projek",
    全部的: "semua",
    小计: "jumlah kecil",
    总运费: "jumlah kos penghantaran",
    有优惠码吗_在这里输入: "Adakah terdapat kod diskaun? masuk sini",
    申请: "Mohon",
    编辑: "edit",
    删除: "padam",
    添加新地址: "tambah alamat baru",
    继续交货信息: "Teruskan maklumat penghantaran",
    选择一个地址: "Pilih alamat",
    购买历史: "Sejarah pembelian",
    下载: "muat turun",
    已发送退款请求: "Permintaan bayaran balik dihantar",
    对比: "Berbanding",
    对话: "dialog",
    我的钱包: "Dompet saya",
    工单: "arahan kerja",
    管理个人资料: "Urus profil",
    登出: "Log keluar",
    重置对比列表: "Tetapkan semula senarai perbandingan",
    您的对比列表为空: "Senarai perbandingan anda kosong",
    在您的购物车中: "dalam troli beli-belah anda",
    在您的愿望清单中: "dalam senarai keinginan anda",
    在您的预定列表中: "pada senarai tempahan anda",
    下载您的产品: "Muat turun produk anda",
    选项: "Pilihan",
    什么都没找到: "Tiada apa-apa Dijumpai",
    特色产品: "Produk pilihan",
    最畅销: "paling laris",
    前_名: "{0} Teratas",
    查看更多: "lihat lagi",
    查看所有类别: "Lihat semua kategori",
    十大品牌: "Sepuluh jenama teratas",
    查看所有品牌: "Lihat semua jenama",
    登录: "Log masuk",
    手机号码: "nombor telefon",
    密码: "kata laluan",
    密码长度为6到16个字符: "Panjang kata laluan ialah 6 hingga 16 aksara",
    验证码: "Kod pengesahan",
    登录中: "Log masuk",
    游客登录: "Log masuk pelawat",
    注册您的商店: "Daftar kedai anda",
    现在申请: "Mohon sekarang",
    成为商家: "Menjadi seorang peniaga",
    现在注册: "Daftar sekarang",
    登录成功: "Berjaya mendarat",
    通知: "maklumkan",
    未找到通知: "pemberitahuan tidak ditemui",
    评论: "Komen",
    估计运输时间: "Anggaran masa penghantaran",
    天: "langit",
    所售: "dijual",
    给商家留言: "Tinggalkan mesej kepada peniaga",
    规格: "Spesifikasi",
    库存: "dalam stok",
    总价: "harga keseluruhan",
    添加到购物车: "Tambah ke Troli",
    立即购买: "Beli sekarang",
    缺货: "kehabisan stok",
    添加到愿望清单: "Tambahkan ke senarai hajat",
    加入对比列表: "Tambahkan ke senarai perbandingan",
    退款: "Bayaran balik",
    查看条款: "Lihat Terma",
    分享: "kongsi",
    描述: "huraikan",
    相关产品: "Produk Berkaitan",
    没有人问过商家: "Tidak ada yang bertanya kepada peniaga",
    该产品暂无评论: "Tiada ulasan untuk produk ini lagi",
    客户评论: "Maklumbalas Pelanggan",
    访问商店: "melawat kedai",
    畅销产品: "Jualan paling laris",
    日期: "Tarikh",
    订单编号: "nombor pesanan",
    总额: "sekali gus",
    状态: "negeri",
    愿望清单: "senarai hajat",
    还没有添加任何东西: "Tiada apa-apa lagi yang ditambah",
    注册: "mendaftar",
    邀请码: "Kod Jemputan",
    请输入邀请码: "Sila masukkan kod jemputan",
    用户名: "nama pengguna",
    请输入用户名: "sila masukkan nama pengguna",
    用户名长度为6_14个字符: "Panjang nama pengguna ialah 6-14 aksara",
    昵称: "nama panggilan",
    请输入手机号码: "Sila masukkan nombor telefon",
    手机号码格式错误: "Format nombor telefon yang salah",
    密码长度为6_16个字符: "Panjang kata laluan ialah 6-16 aksara",
    确认密码: "Sahkan Kata Laluan",
    请输入确认密码: "Sila masukkan kata laluan pengesahan",
    提款密码: "Kata laluan pengeluaran",
    请输入提款密码: "Sila masukkan kata laluan pengeluaran",
    提款密码长度为4_16个字符: "Panjang kata laluan pengeluaran ialah 4-16 aksara",
    请输入验证码: "sila masukkan kod pengesahan",
    在_s后发送: "Dihantar selepas {0}s",
    发送验证码: "Hantar kod pengesahan",
    注册即表示您同意我们的条款和条件: "Dengan mendaftar anda bersetuju dengan terma dan syarat kami.",
    创建账号: "Buat akaun",
    验证码发送成功: "Kod pengesahan berjaya dihantar",
    确认密码不一致: "Sahkan bahawa kata laluan tidak konsisten",
    提款密码必须为数字: "Kata laluan pengeluaran mestilah berangka",
    注册成功: "pendaftaran berjaya",
    购物车: "troli beli-belah",
    账户: "Akaun",
    我的账户: "akaun saya",
    已经有一个账户: "Sudah mempunyai akaun",
    新地址: "alamat baru",
    编辑地址: "Edit alamat",
    保存: "jimat",
    是否默认: "Adakah ia lalai",
    具体地址: "Alamat khusus",
    请输入具体地址: "Sila masukkan alamat tertentu",
    地区: "kawasan",
    请输入地区: "Sila masukkan wilayah",
    城市: "Bandar",
    请输入城市: "Sila masukkan bandar",
    省份: "wilayah",
    请输入省份: "Sila masukkan wilayah",
    邮政编码: "Poskod",
    请输入邮政编码: "Sila masukkan poskod",
    电话号码: "nombor telefon",
    请输入电话号码: "Sila masukkan nombor telefon anda",
    收货人: "Penerima",
    请输入收货人: "Sila masukkan penerima",
    保存成功: "Berjaya disimpan",
    最畅销的商家: "Peniaga Terlaris",
    查看所有的商家: "Lihat semua perniagaan",
    支持政策: "Dasar sokongan",
    您的电子邮件地址: "alamat e-mel anda",
    订阅: "langganan",
    联系方式: "Maklumat perhubungan",
    地址: "alamat",
    美国伊利诺伊州霍夫曼庄园: "Hoffman Estates, Illinois, Amerika Syarikat",
    快速链接: "Pautan Pantas",
    商家政策: "Dasar pedagang",
    submit: "menyerahkan",
    提款银行卡: "Kad bank pengeluaran",
    我的面板: "panel saya",
    提示: "petunjuk",
    确定登出吗: "Adakah anda pasti mahu log keluar?",
    确定: "pasti",
    取消: "Batal",
    项目添加到您的购物车: "Tambahkan item pada troli beli-belah anda",
    经常一起购买: "sering beli bersama",
    返回购物: "Kembali membeli-belah",
    进行结算: "teruskan ke pembayaran",
    帮助热线: "Talian bantuan",
    查看所有通知: "Lihat semua pemberitahuan",
    请输入密码: "Sila masukkan kata laluan",
    前往充值: "Pergi untuk mengisi semula",
    购物车物品: "Barangan troli beli-belah",
    查看购物车: "semak troli beli-belah",
    钱包余额: "baki dompet",
    充值钱包: "Isi semula dompet",
    钱包充值_线下_: "Caj semula dompet (luar talian)",
    申请提款: "Mohon untuk pengeluaran",
    钱包收支明细: "Butiran Pendapatan dan Perbelanjaan Wallet",
    批准: "terima",
    提现历史记录: "Sejarah pengeluaran",
    类型: "menaip",
    信息: "maklumat",
    付款方式: "kaedah pembayaran",
    请选择付款方式: "Sila pilih kaedah pembayaran",
    Bill_Type_RECHARGE_BACK: "Caj semula bahagian belakang",
    Bill_Type_RECHARGE_ONLINE: "Caj semula dalam talian",
    Bill_Type_RECHARGE_REGISTER: "Daftar percuma",
    Bill_Type_RECHARGE_JACKPOT: "Bonus cas semula",
    Bill_Type_RECHARGE_PRESENT: "Recharge ganjaran",
    Bill_Type_RECHARGE_FROM_COMMISSION: "Pemindahan komisen",
    Bill_Type_RECHARGE_TG_COMMISSION: "Komisen promosi cas semula",
    Bill_Type_REGISTER_TG_COMMISSION: "Komisen kenaikan pangkat pendaftaran",
    Bill_Type_WITHDRAW: "menarik diri",
    Bill_Type_WITHDRAW_REJECT: "Pengeluaran ditolak",
    Bill_Type_DEDUCT_HANDLE: "Potongan manual",
    Bill_Type_DEDUCT_RECHARGE_MONEY: "Pembetulan cas semula",
    Bill_Type_MINING_PROFIT: "Pendapatan perlombongan",
    Bill_Type_MINING_PROFIT_COMMISSION: "Komisen promosi pendapatan perlombongan",
    Bill_Type_VIP_UPGRADE: "Tingkatkan VIP",
    Bill_Type_FINANCE_BUY: "Beli produk kewangan",
    Bill_Type_FINANCE_CAPITAL_RETURN: "Pulangan baki kewangan",
    Bill_Type_FINANCE_FEE: "Yuran pengurusan kewangan",
    Bill_Type_FINANCE_PROFIT: "Pendapatan pengurusan kewangan",
    Bill_Type_FINANCE_BUY_COMMISSION: "Komisen untuk membeli produk kewangan",
    Bill_Type_FINANCE_PROFIT_COMMISSION: "Komisen pendapatan produk kewangan",
    Bill_Type_WHEEL_DRAW: "Loteri roda besar",
    Bill_Type_BUY: "beli barang",
    Bill_Type_PAY_SHOP: "Bayar untuk penghantaran",
    Bill_Type_BUY_COMMISSION: "Komisen untuk barang yang dibeli",
    Bill_Type_DEPOSIT: "Bayar deposit",
    Bill_Type_STORE_BUY: "beli barang",
    Bill_Type_STORE_BUY_REFUND: "Bayaran balik produk belian",
    Bill_Type: "Jenis perubahan akaun",
    Before_Money: "jumlah sebelumnya",
    Deal_Money: "Jumlah perubahan akaun",
    After_Money: "Jumlah selepas",
    Bill_Time: "Masa tukar akaun",
    No_More_Data: "tiada lagi data",
    Apply_Money: "Amaun Permohonan",
    Apply_Time: "masa permohonan",
    Withdraw_Info: "Yuran pengendalian: {fee}, ketibaan: {money}",
    提款订单状态_CHECKING: "Semakan belum selesai",
    提款订单状态_TRANSFERRING: "Memindahkan",
    提款订单状态_PASS: "disahkan",
    提款订单状态_REJECT: "Diketepikan",
    暂无可用充值方式: "Tiada kaedah cas semula tersedia lagi",
    钱包收款码: "Kod pembayaran dompet",
    钱包地址: "alamat dompet",
    金额限制: "Had amaun",
    复制: "salinan",
    付款凭证: "baucar bayaran",
    收款银行: "Bank Penerima",
    收款人: "Penerima bayaran",
    收款账号: "Nombor akaun pembayaran",
    付款银行: "bank pembayaran",
    付款人: "Pembayar",
    付款账号: "Akaun pembayaran",
    请输入付款银行: "Sila masukkan bank pembayaran",
    请输入付款人: "Sila masukkan pembayar",
    请输入付款账号: "Sila masukkan nombor akaun pembayaran",
    请上传付款凭证: "Sila muat naik baucar pembayaran",
    充值金额: "Jumlah cas semula",
    请输入充值金额: "Sila masukkan jumlah caj semula",
    submitting: "menyerahkan...",
    Confirm: "menyerahkan",
    Commit_Success: "Dihantar dengan jayanya",
    balanceType_BALANCE: "seimbang",
    balanceType_COMMISSION: "komisen",
    Balance: "Baki akaun",
    Wash_Money: "tambah mozek",
    请选择银行账户: "Sila pilih akaun bank",
    卡号类型: "Jenis nombor kad",
    提现金额: "Jumlah Pengeluaran",
    提款金额: "Jumlah pengeluaran",
    不能为空: "Tidak boleh kosong",
    金额不正确: "Jumlahnya tidak betul",
    please_input_withdraw_password: "Sila masukkan kata laluan pengeluaran",
    withdraw_password_format_error: "Kata laluan pengeluaran mestilah 4-16 aksara",
    Fee: "yuran pengendalian",
    实际到账: "Ketibaan sebenar",
    交易币种: "Mata wang urus niaga",
    原始密码: "kata laluan asal",
    confirm_password_error: "Kata laluan yang dimasukkan dua kali adalah salah",
    save_success: "Berjaya disimpan",
    please_input: "sila masukkan",
    old_password: "Kata laluan lama",
    new_password: "Kata laluan baharu",
    please_input_confirm_password: "Sila sahkan kata laluan sekali lagi",
    没有找到符合条件的商品: "Tiada produk yang sepadan ditemui",
    Search: "cari",
    全部: "semua",
    EnumGoodsOrderState_USER_PAY: "Menunggu penghantaran",
    EnumGoodsOrderState_SHOP_PAY: "Menyampaikan",
    EnumGoodsOrderState_SUCCESS: "Selesai",
    EnumGoodsOrderState_CANCEL: "Dibatalkan",
    EnumGoodsOrderState_REFUND_SUCCESS: "dikembalikan",
    订单号: "nombor pesanan",
    用户名称: "nama pengguna",
    收益: "pendapatan",
    支付时间: "Masa pembayaran",
    配送时间: "Masa penghantaran",
    完成时间: "masa yang lengkap",
    发货: "kapal",
    全选: "pilih semua",
    物品已添加到愿望清单: "Item ditambahkan pada senarai hajat",
    物品已添加到比较列表: "Item ditambahkan pada senarai perbandingan",
    购买成功提示: "Tahniah, pembelian anda berjaya",
    订单列表: "Senarai Pesanan",
    商品名: "Nama Produk",
    图片: "gambar",
    没有品牌: "tiada jenama",
    基本信息: "Maklumat asas",
    Account_Name: "Nama pembukaan akaun",
    Bank_Account: "Akaun bank",
    Bank_Phone: "Tempah nombor telefon bimbit",
    IFSC: "akaun IFSC",
    UPI: "akaun UPI",
    PIX: "akaun PIX",
    CPF: "akaun CPF",
    GCASH: "akaun GCASH",
    POWWI: "akaun POWWI",
    身份证号: "nombor ID",
    Edit: "Semak semula",
    Delete: "padam",
    Add: "Baru",
    Forget_Withdraw_Password: "Terlupa kata laluan pengeluaran",
    Bank_Card_Info: "Maklumat kad bank",
    收款人地址: "Alamat Penerima",
    SWIFT: "SWIFT",
    Bank_Branch: "Nama cawangan",
    分行代码: "kod Cawangan",
    银行地址: "alamat bank",
    Email: "E-mel",
    银行卡长度必须超过: "Panjang kad bank mesti melebihi {length}",
    银行卡格式不正确: "Format kad bank tidak betul",
    Do_you_confirm_delete: "Sahkan pemadaman?",
    Please_Login_First: "sila log masuk dahulu",
    Bank_Name: "nama bank",
    Please_add_bank_first: "Anda belum mengikat kad bank anda lagi, sila tambahkannya dahulu",
    withdrawType: "Jenis pengeluaran",
    withdraw_money_limit: "Amaun pengeluaran mesti lebih besar daripada 0 dan kurang daripada atau sama dengan {balance}",
    withdraw_times_limit: "Anda telah mengeluarkan {todayWithdrawNum} kali hari ini dan yuran pengendalian sebanyak {withdrawFee}% akan dikenakan selepas {limitTimes} kali. Adakah anda pasti akan menarik diri?",
    Copy_Success: "Berjaya disalin",
    商店首页: "Laman utama kedai",
    所有产品: "Semua produk",
    新到货产品: "Produk yang baru sampai",
    所有商家: "Semua peniaga",
    请上传: "Sila muat naik",
    请输入: "sila masukkan",
    忘记密码: "lupa kata laluan",
    记得我: "ingat saya",
    共_件: "Jumlah {0} item",
    取消订单: "membatalkan pesanan",
    申请退款: "Minta bayaran balik",
    未知商家: "Pedagang tidak dikenali",
    到账: "resit",
    提款订单状态: "Status pesanan pengeluaran",
    前_名类别: "{0} kategori teratas",
    取消订单原因_不想要了: "Tidak mahu lagi",
    取消订单原因_商品错选_多选: "Pemilihan produk yang salah/pelbagai pilihan",
    取消订单原因_商品无货: "Produk kehabisan stok",
    取消订单原因_地址信息填写错误: "Maklumat alamat diisi dengan salah",
    取消订单原因_商品降价: "Pengurangan harga produk",
    取消订单原因_价格高于其他平台: "Harganya lebih tinggi daripada platform lain",
    取消订单原因_没用_少用_错用优惠: "Tiada guna/kurang guna/salah guna diskaun",
    退款原因_拍错_多拍_不喜欢: "Tangkapan salah / tangkapan tambahan / tidak menyukainya",
    退款原因_商品成分描述不符: "Penerangan ramuan produk tidak sepadan",
    退款原因_与商家协商一致退款: "Bayaran balik seperti yang dipersetujui dengan pedagang",
    退款原因_生产日期_保质期与商品描述不符: "Tarikh pengeluaran/jangka hayat tidak sepadan dengan penerangan produk",
    退款原因_图片_产地_批号_规格等描述不符: "Gambar/asal asal/nombor kelompok/spesifikasi dan keterangan lain tidak sepadan",
    退款原因_质量问题: "Isu kualiti",
    退款原因_商品变质_发霉_有异物: "Produk rosak/berkulat/ada bendasing",
    退款原因_少件_含缺少配件_: "Beberapa helai (termasuk aksesori yang hilang)",
    退款原因_收到商品时有破损_污渍_变形: "Barang telah rosak/kotor/cacat semasa diterima.",
    退款原因_假冒品牌: "Jenama tiruan",
    退款原因_发票问题: "Isu invois",
    退款原因_商家发错货: "Peniaga itu menghantar barang yang salah",
    退款原因_预约不到_商家不给退换: "Tidak boleh membuat temu janji/peniaga tidak akan memberikan pulangan atau pertukaran",
    退款失败: "Bayaran balik gagal",
    退款处理中: "Bayaran balik sedang dijalankan",
    默认: "lalai",
    产品查询: "Carian Produk",
    商店LOGO: "LOGO kedai",
    推广码: "Kod promosi",
    查看所有: "lihat semua",
    确认收货成功: "Sahkan penerimaan barang dengan jayanya",
    物流公司: "syarikat logistik",
    物流单号: "nombor penghantaran",
    发货时间: "Masa penghantaran",
    请先选择商品规格: "Sila pilih spesifikasi produk dahulu",
    个人信息: "maklumat peribadi",
    您的用户名: "nama pengguna anda",
    你的名字: "nama awak",
    登录名: "nama pengguna",
    你的邮件: "emel anda",
    你的密码: "kata laluan Awak",
    重复输入密码: "Ulang kata laluan",
    店铺名称: "Nama kedai",
    证书类型: "Jenis Sijil",
    身份证: "kad pengenalan",
    护照: "pasport",
    驾驶执照: "lesen memandu",
    社会保障卡: "Kad keselamatan sosial",
    证书正面: "hadapan sijil",
    证书反面: "Bahagian belakang sijil",
    确认收货: "mengesahkan penerimaan barang",
    请选择取消订单的原因必选: "Sila pilih sebab untuk membatalkan pesanan (diperlukan):",
    请选择申请退款的原因必选: "Sila pilih sebab untuk meminta bayaran balik (diperlukan):",
    留言: "mesej",
    请输入留言: "Sila masukkan mesej",
    没有帐户: "Tiada akaun",
    钱包充值: "Caj semula dompet",
    输入您的文字: "Masukkan teks anda",
    商家登录: "Log masuk pedagang",
    有关此产品的任何查询: "Sebarang pertanyaan tentang produk ini",
    产品名称: "Nama Produk",
    你的问题: "masalah awak",
    白银店铺: "kedai perak",
    铂金店铺: "kedai platinum",
    钻石店铺: "kedai berlian",
    照片: "foto",
    已退货: "Dipulangkan",
    邮寄状态: "Status mel",
    订单摘要: "Ringkasan pesanan",
    收件地址: "Alamat penerima",
    订购日期: "Tarikh pesanan",
    订单状态: "Status pesanan",
    总订单金额: "Jumlah jumlah pesanan",
    邮寄方式: "Kaedah mel",
    附加信息: "Maklumat tambahan",
    订单详细信息: "Maklumat pesanan",
    交货类型: "Jenis penghantaran",
    进行评论: "Buat komen",
    已评论: "mengulas",
    订单金额: "jumlah pesanan",
    优惠券: "kupon",
    统一运费: "Bayaran penghantaran rata",
    送货地址: "Alamat Penghantaran",
    评分: "skor",
    你的意见: "pendapat anda",
    匿名: "tanpa nama",
    现金: "tunai",
    详情: "Butiran",
    收货地址: "Alamat penghantaran",
    暂时没有对话: "Tiada perbualan lagi",
    你: "awak",
    输入您的回复: "Masukkan balasan anda",
    删除成功: "berjaya dipadamkan",
    品牌: "jenama",
    已缴纳的保证金: "Deposit keselamatan dibayar",
    黄金店铺: "kedai emas",
    没有更多数据: "tiada lagi data",
    站内信: "Mesej tapak",
    系统通知: "pemberitahuan sistem",
    邮箱: "Mel",
    手机号: "Nombor telefon",
    你的手机号: "nombor telefon anda",
    营业执照: "lesen perniagaan",
    你的邮箱: "peti mel anda",
    搜索结果: "Keputusan Carian",
    系统公告: 'pemberitahuan sistem',
    客服: "khidmat Pelanggan",
    消息已撤回: 'Mesej telah ditarik balik',
    物流详情: 'Butiran logistik',
    充值: 'Tambah nilai',
    提现: 'menarik diri',
    信用分: 'skor kredit',
    余额: 'seimbang',
    佣金: 'komisen',
    继续购物: 'terus membeli-belah',
    订单结算: 'Penyelesaian pesanan',
    加入对比: 'Tambah sebagai perbandingan',
    佣金余额: "Baki komisen",
    刷新: "segarkan semula",
    刷新成功: "Segar semula berjaya",
    官网: "Laman web rasmi",
    税号: 'Nombor ID cukai',
    订单: 'Pesanan',
    合计: "jumlah",
    系统安全: "Keselamatan sistem",
    Recharge_Money_Limit: 'Jumlah cas semula mestilah antara {min} dan {maks}',
    限时优惠: 'Tawaran masa terhad',
    高价回收: 'Kitar semula harga tinggi',
    姓名: 'Nama',
    商品订单号: 'Nombor pesanan produk',
    商品在线回收: 'Kitar semula dalam talian produk',
    提交: 'serahkan',
    回收记录: 'Rekod kitar semula',
    回收状态: 'Status kitar semula',
     回收价格: 'harga kitar semula',
     纳税码: 'kod cukai',
     买家登录: 'Log masuk',
     买家注册: 'mendaftar',
     任務: 'Tugas',
     下单失败_请稍后重试: 'Pesanan gagal, sila cuba lagi kemudian',
     "language": "马来语"
};
;
